// The rounded_rect function that you provided
export function rounded_rect(
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number,
  topLeft: boolean,
  topRight: boolean,
  bottomLeft: boolean,
  bottomRight: boolean
) {
  let path = `M${x + radius},${y}`
  path += `h${width - 2 * radius}`
  path += topRight ? `a${radius},${radius} 0 0 1 ${radius},${radius}` : `h${radius}v${radius}`
  path += `v${height - 2 * radius}`
  path += bottomRight ? `a${radius},${radius} 0 0 1 ${-radius},${radius}` : `v${radius}h${-radius}`
  path += `h${2 * radius - width}`
  path += bottomLeft ? `a${radius},${radius} 0 0 1 ${-radius},${-radius}` : `h${-radius}v${-radius}`
  path += `v${2 * radius - height}`
  path += topLeft ? `a${radius},${radius} 0 0 1 ${radius},${-radius}` : `v${-radius}h${radius}`
  path += 'z'
  return path
}
